import { WaterAllocationsPage } from "./WaterAllocationsPage";

const WaterAllocations = () => {
	return <WaterAllocationsPage />;
};

export default WaterAllocations;
